<ng-template [ngIf]="inserimento">
	<div class="col-sm-12 coldx" 
		[ngStyle]="{ 'display' : ( visibleToggleAssocia ? 'block' : 'none') }">
		<h4 *ngIf="title">{{title}}</h4>
		<small id="cerca-ass-controparte" class="sr-only">Cerca associazione controparte</small>
		<form aria-labelledby="cerca-ass-controparte" class="cerca_grey">
			<div class="row">
				<p class="col-sm-12">
					<label>Cerca</label> <input type="text" #searchItem (keyup)="0"
						class="form-control" placeholder="Inserisci nome e cognome" />
				</p>
			</div>
		</form>
	<ng-template [ngIf]="partiAll && partiAll.length > 0">
	<ng-template ngFor let-parte [ngForOf]="partiAll  | searchFilter : searchItem.value : 'parteReato.persona.nominativo'">
		<ul id="controparticollapse" class="controparti">		
			<li class="panel">
				<div class="controparte">
					<div>
						<p class="col-xs-12 col-sm-2">
							<button class="btn btn-primary associa"
								(click)="setParte(parte);" type="submit">Associa</button>
						</p>
						<h4 class="titolo col-sm-3">{{ parte.parteReato.persona.nominativo }}</h4>
						<ng-template [ngIf]="parte.parteReato.persona.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
							<p class="col-sm-3">
								C/F: <strong> {{ parte.parteReato.persona.codiceFiscale }} </strong>
							</p>
						</ng-template>
						<ng-template
							[ngIf]="parte.parteReato.persona.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
							<p class="col-sm-3">
								P.IVA: <strong> {{ parte.parteReato.persona.partitaIva }} </strong>
							</p>
						</ng-template>
						<p class="col-sm-2">
							<strong>{{parte.parteReato.categoria ? parte.parteReato.categoria : ''}}</strong>
						</p>
					</div>
				</div>
			</li>
		</ul>
	</ng-template></ng-template>
	<ng-template [ngIf]="(!partiAll || partiAll.length == 0) && msgNoParti">
		<p>{{msgNoParti}}</p>
	</ng-template>
	</div>
</ng-template>

<ng-template [ngIf]="reatoForm">
<div class="col-sm-12 coldx" 
	[ngStyle]="{ 'display' : ( visibleToggleForm ? 'block' : 'none') }">
	<h4 *ngIf="title">{{title}}</h4>
	<div class="tab-content">
		<form [formGroup]="reatoForm" (ngSubmit)="save();">
			<div class="row">
				<ng-template [ngIf]="!inserimento">
					<div class="row">
						<div *ngIf="getParteReato(reato).tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA"
							labelTextInput class="col-sm-4 bloccodati"
							[typeLabel]="'text'" [labelInput]="'Cognome e Nome'"
							[valueInput]="getParteReato(reato).nominativo"></div>
						<div *ngIf="getParteReato(reato).tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA"
							labelTextInput class="col-sm-4 bloccodati"
							[typeLabel]="'text'" [labelInput]="'Ragione sociale'"
							[valueInput]="getParteReato(reato).nominativo"></div>
						<div *ngIf="getParteReato(reato).tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA"
							 labelTextInput class="col-sm-4 bloccodati"
							[typeLabel]="'text'" [labelInput]="'C.F.'"
							[valueInput]="getParteReato(reato).codiceFiscale">
						</div>
						<div *ngIf="getParteReato(reato).tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA"
							 labelTextInput class="col-sm-4 bloccodati"
							[typeLabel]="'text'" [labelInput]="'Partita iva'"
							[valueInput]="getParteReato(reato).partitaIva">
						</div>
						<div labelTextInput class="col-sm-4 bloccodati"
							[typeLabel]="'text'" [labelInput]="'Categoria'"
							[valueInput]="reato.controparte?.categoria.label">
						</div>
					</div>
				</ng-template>
				<ng-template [ngIf]="inserimento && parteView && parteView?.persona.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
					<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
						[labelInput]="'Cognome e nome'"
						[valueInput]="parteView?.persona.cognome+' '+parteView?.persona.nome"></div>
					<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
						[labelInput]="'Codice Fiscale'"
						[valueInput]="parteView?.persona.codiceFiscale ? parteView.persona.codiceFiscale : ''"></div>
				</ng-template>
				<ng-template [ngIf]="inserimento && parteView && parteView?.persona.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
					<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
						[labelInput]="'Ragione sociale'"
						[valueInput]="parteView?.persona.ragioneSociale"></div>
					<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
						[labelInput]="'Partita Iva'"
						[valueInput]="parteView?.persona.partitaIva ? parteView.persona.partitaIva : ''"></div>				
				</ng-template>
				<ng-template [ngIf]="inserimento">
					<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
						[labelInput]="'Categoria'"
						[valueInput]="parteView?.categoria ? parteView?.categoria : ''">
					</div>
				</ng-template>		
			</div>
			<div class="row" formArrayName="datiReato">
				<div [formGroupName]="0" class="row">
					<div textInput class="col-sm-3" [labelInput]="'Norma'"
						formControlName="articolo" [mandatory]="true"></div>
					<div datePickerInput class="col-sm-3" [mandatory]="true"
						formControlName="dataReato" [labelInput]="'Data reato'"></div>
					<div textInput class="col-sm-3" [labelInput]="'Luogo reato'"
						formControlName="luogoReato" [mandatory]="true"></div>
					<div textInput class="col-sm-3" [labelInput]="'Note'"
						formControlName="note"></div>                    
				</div>
			</div>	
			<!-- <div class="row">
				<div textAreaInput class="col-xs-12 col-sm-12" [labelInput]="'Note'"
					formControlName="note" [(ngModel)]="request.note"></div>
			</div> -->
			<div class="row">
				<p class="mandatory col-sm-12">
					<em>* Campi obbligatori</em>
				</p>
			</div>
			<div class="row">
				<p class="col-sm-3 col-xs-6">					
					<button type="button" class="btn btn-outline-secondary btn-block"
						(click)="reset();">Reset</button>
					
				</p>
				<p class="col-sm-3 col-xs-6 col-sm-offset-6">			
					<button type="button" class="btn btn-primary btn-block"
						(click)="aggiungi();" [disabled]="!reatoForm.valid">{{ indexToEdit !== null ? 'Modifica' : 'Aggiungi' }}</button>				
				</p>
			</div>

			<div class="row">
				<div class="col-sm-12">
					<table class="table-striped table aggiunta_classificazione">
						<caption class="sr-only">Tabella reati</caption>
						<tbody>
							<tr>
							<th scope="col">Norma</th>
							<th scope="col">Data Reato</th>
							<th scope="col">Luogo Reato</th>
							<th scope="col">Note</th>
							<th scope="col">Azioni</th>
							</tr>
							<ng-container *ngFor="let reatoItem of reati; let i = index">
								<tr>
									<td>{{ reatoItem?.articolo }}</td>
									<td>{{ reatoItem?.dataReato | date:'dd/MM/yyyy' }}</td>
									<td>{{ reatoItem?.luogoReato }}</td>
									<td>{{ reatoItem?.note }}</td>
									<td style="display: flex; justify-content: center; color: #204d74;">
									<a href="javascript:void(0);" aria-label="modifica reato"
										[ngClass]="{'link-grey': indexToEdit === i}"
										(click)="elimina(i);">
										<span class="glyphicon glyphicon-trash"></span>
									</a>
									<a href="javascript:void(0);" aria-label="elimina reato"
										[ngClass]="{'link-grey': indexToEdit === i}"
										(click)="modifica(i);">
										<span class="glyphicon glyphicon-pencil"></span>
									</a>
									</td>
								</tr>
							</ng-container>
							<tr *ngIf="reati?.length === 0">
								<td colspan="5" style="text-align: center;">Nessun reato aggiunto</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>

			<div class="row">
				<p class="col-sm-3 col-xs-6">
					<ng-template [ngIf]="inserimento">
						<button type="button" (click)="goToAssocia();"
							class="btn btn-outline-secondary btn-block">Indietro</button>
					</ng-template>
				</p>
				<p submitButton [disabled]="reati.length === 0"
					class="col-sm-3 col-xs-6 col-sm-offset-6"
					[labelButton]="'Salva'"></p>
			</div>
		</form>
	</div>
</div>
</ng-template>
